let username = "";

const pathArray = window.location.pathname.split("/").filter(Boolean);

if (pathArray.includes("Login")) {
    // Handle special case when URL contains "Login"
    username = pathArray[1];
} else {
    username = pathArray[0] 
}

let data = JSON.parse(localStorage.getItem(`logindata_${username}`))
/*let me = ''
if (pathArray.includes("FamilyChart")) {
    me = `https://welcometowedding.com/events/68666e7d5690bd19063d705d/`
}else{
me =`https://welcometowedding.com/events/${data?._id}/`
}*/
let me =`https://welcometowedding.com/events/${data?._id}/`

export const EVENT_BASEURL = me
export const AUTH_TOKEN_KEY = "authToken";
export const LOGIN_DATA = "logindata"
